import { modal } from "@/components/additional/modal.js";
import { eventEmitter } from "@/utils/event-emitter.js";
import { appState } from "@/utils/state.js";
import { arraysMatch } from "@/lib/arr-match.js";
import { showSolution } from "@/core/showSolution.js";
import { getLS } from "@/utils/local-storage.js";

export function userClick() {
  eventEmitter.on("userClick", (params) => {
    const { e, i } = params;
    const userArr = appState.getState("userInput");
    const puzzleArr = appState.getState("matrix").flat();
    const clickSound = new Audio("/sounds/click.mp3");

    if (getLS("sound") === "on") {
      clickSound.currentTime = 0;
      clickSound.play();
    }

    e.preventDefault();

    document.addEventListener("contextmenu", (event) => {
      event.preventDefault();
    });

    if (e.button === 0) {
      e.target.classList.toggle("dark");
      e.target.classList.remove("x");

      if (userArr[i] === 1) {
        userArr[i] = 0;
      } else {
        userArr[i] = 1;
      }
      appState.setState("userInput", userArr);
      if (arraysMatch(puzzleArr, userArr)) {
        modal(document.querySelector("body"));
        showSolution();
        eventEmitter.emit("solution");
      }
      console.log(puzzleArr, userArr);
    }
    if (e.button === 2) {
      e.target.classList.toggle("x");
      e.target.classList.remove("dark");
      if (userArr[i] === 2) {
        userArr[i] = 0;
      } else {
        userArr[i] = 2;
      }

      appState.getState("userInput", userArr);
    }
  });
}
